import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap.js';

// Whooohoo!
let ElementRoutes = {
    '.scrollmagic-banner-parallax' () {
        require.ensure([], () => {
            require('./scenes/banner-parallax.js');
        });
    },
    '.scrollmagic-parallax1' () {
        require.ensure([], () => {
            require('./scenes/parallax1.js');
        });
    },
};

$.each(ElementRoutes, (key, callback) => {
    if (document.querySelectorAll(key).length) {
        callback();
        console.info('✓ scene: ' + key);
    }
});
